
// Main IIFE to avoid global scope pollution
(function() {
    'use strict';

    // Product Filter Hacks
    let filter = document.querySelector(".widget.widget_wpc_filters_widget");
    if (filter) {
        // Add open filter control
        document.querySelector(".woocommerce-products-header div.page-description").insertAdjacentHTML("beforeend", "<button class='open-filter'>Filter</button>");
        document.querySelector(".open-filter").addEventListener("click", function () {
            filter.classList.toggle("open");
            this.classList.toggle("is-open");
            // Show overlay when filter is open and hide when filter is closed
            document.querySelector("#filter-overlay").classList.toggle("is-open", filter.classList.contains("open"));
            // Prevent body from scrolling when filter is open
            document.body.classList.toggle("no-scroll", filter.classList.contains("open"));
        });
        // Add close filter control
        filter.insertAdjacentHTML("afterbegin", "<button class='close-filter'>Filter</button>");
        document.querySelector(".close-filter").addEventListener("click", function () {
            filter.classList.toggle("open");
            document.querySelector(".open-filter").classList.toggle("is-open");
            // Show overlay when filter is open and hide when filter is closed
            document.querySelector("#filter-overlay").classList.toggle("is-open", filter.classList.contains("open"));
            // Prevent body from scrolling when filter is open
            document.body.classList.toggle("no-scroll", filter.classList.contains("open"));
        });
        // Add filter overlay
        document.querySelector(".woocommerce-products-header").insertAdjacentHTML("beforeend", "<div id='filter-overlay'></div>");
        // Close filter when overlay is clicked
        document.querySelector("#filter-overlay").addEventListener("click", function () {
            filter.classList.remove("open");
            document.querySelector(".open-filter").classList.remove("is-open");
            this.classList.remove("is-open");
            document.body.classList.remove("no-scroll");
        });
        // Close filter when esc key is pressed
        document.addEventListener("keydown", function (e) {
            if (e.key === "Escape") {
                filter.classList.remove("open");
                document.querySelector(".open-filter").classList.remove("is-open");
                document.querySelector("#filter-overlay").classList.remove("is-open");
                document.body.classList.remove("no-scroll");
            }
        });

        // Show labels in price slider
        jQuery(document).on('ready', function (e) {
            var minPrice = document.querySelector(".wpc-filters-range-wrapper input.wpc-filters-range-min").value;
            var maxPrice = document.querySelector(".wpc-filters-range-wrapper input.wpc-filters-range-max").value;
            document.querySelector(".wpc-filters-range-slider-wrapper").insertAdjacentHTML("beforeend", "<div class='price-labels'><span class='price-min'>" + minPrice + " &euro;</span><span class='price-min'>" + maxPrice + " &euro;</span></div>");
        });

    }

    // mobile navigation hack
    document.querySelector(".navbar-toggler").addEventListener("click", function () {
        document.body.classList.toggle("no-scroll");
    });


    // Product gallery
    window.addEventListener('load', function () {
        let thumbsWrapper = document.querySelector('ol.flex-control-nav.flex-control-thumbs');
        if (thumbsWrapper) {
            let images = thumbsWrapper.querySelectorAll('img');
            let totalImages = images.length;
            let loadedImages = 0;

            if (totalImages === 0) {
                initializeThumbSwiper();
            } else {
                images.forEach(img => {
                    if (img.complete) {
                        loadedImages++;
                        if (loadedImages === totalImages) {
                            initializeThumbSwiper();
                        }
                    } else {
                        img.addEventListener('load', () => {
                            loadedImages++;
                            if (loadedImages === totalImages) {
                                initializeThumbSwiper();
                            }
                        });
                    }
                });
            }

            function initializeThumbSwiper() {
                thumbsWrapper.classList.add('swiper-wrapper');
                let listItems = thumbsWrapper.querySelectorAll('li');
                listItems.forEach(item => {
                    item.classList.add('swiper-slide');
                });
                var $loop = listItems.length > 4 ? true : false;
                let wrapperDiv = document.createElement('div');
                wrapperDiv.classList.add('swiper-gallery');
                thumbsWrapper.parentNode.insertBefore(wrapperDiv, thumbsWrapper);
                wrapperDiv.appendChild(thumbsWrapper);

                new Swiper(".swiper-gallery", {
                    slidesPerView: 4,
                    spaceBetween: 4,
                    loop: $loop,
                    slideToClickedSlide: true,
                });
            }
        }

        new Swiper(".swiper-container", {
            slidesPerView: 3.75,
            spaceBetween: 5,
            centerInsufficientSlides: true,
            slidesOffsetAfter: 80,
            slidesOffsetBefore: 80,
            freeMode: {
                enabled: true,
                sticky: true,
            },
            breakpoints: {
                1200: {
                    slidesPerView: 3.75
                },
                768: {
                    slidesPerView: 2.75,
                    slidesOffsetAfter: 40,
                    slidesOffsetBefore: 40,
                },
                300: {
                    slidesPerView: 1.25,
                    slidesOffsetAfter: 0,
                    slidesOffsetBefore: 0,
                }
            }
        });
    });



})();